import styled from 'styled-components';
import { ReservationFeeStyled } from '../ReservationFeeStyled';

export const ReservationFeeStyledDS = styled(ReservationFeeStyled)``;
